export const PARTIAL_U_ACCOUNT_ID = '{unite_account_id}'
export const PARTIAL_U_USER_ID = '{unite_user_id}'
export const PARTIAL_U_BASE = '{unite_api}'
export const PARTIAL_U_TOKEN = '{unite_token}'
export const PARTIAL_P_API = '{public_api}'

const URL_U_BASE_V2 = `${PARTIAL_U_BASE}/api/v2/`
const URL_P_BASE = `${PARTIAL_P_API}/v2/`

export const URL_U_ACCOUNT = `${PARTIAL_U_BASE}/api/accounts/${PARTIAL_U_ACCOUNT_ID}`
export const URL_U_DEPARTMENTS = `${URL_U_ACCOUNT}/departments?includeLineNumbersFlag=Y` // TODO should these be included?
export const URL_U_CALL_QUEUES = `${URL_U_BASE_V2}call-queues?limit=100`
export const URL_U_WELCOME_MENUS = `${URL_U_ACCOUNT}/multiautoattendants`
export const URL_U_USER = `${URL_U_ACCOUNT}/users/${PARTIAL_U_USER_ID}`
export const URL_U_CND_INFO = `${URL_U_USER}/cndinfo`
export const URL_U_CND = `${URL_U_USER}/cnd`
export const URL_U_WEBRTC = `${URL_U_USER}/devices/webapp`
export const URL_U_CONTACTS_LIST = `${URL_P_BASE}unified-contacts`
// TODO update when urls are sanitized
export const URL_U_RING_GROUPS = `${PARTIAL_U_BASE}/api/account/${PARTIAL_U_ACCOUNT_ID}/ringGroups`
